import * as Yup from "yup";

/** Optional phone: validate length only when a value is provided. */
export const optionalTelephoneYup = (t) =>
  Yup.string()
    .transform((value) => (value == null || value === "" ? undefined : value))
    .notRequired()
    .min(8, t("bookingPhoneTooShort"));
